import { FC, HTMLAttributes, memo, useCallback, MouseEvent } from 'react';
import cn from 'classnames';

import Link from '@Navigation/Link';
import List from '@UI/List';
import BackgroundImage from '@UI/BackgroundImage';
import { ColorData } from '@Types/Product';
import styles from './Fabrics.module.css';

export interface FabricsProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  fabrics: ColorData[];
  defaultSelectedFabric?: ColorData;
  size?: 's' | 'm' | 'l';
  onChangeProduct?: (id: number) => void;
  onVariantsLoad?: () => void;
  onClickColor?: (e: MouseEvent, clickedFabric: ColorData) => void;
}

const Fabrics: FC<FabricsProps> = (props) => {
  const {
    className,
    fabrics,
    defaultSelectedFabric,
    size = 's',
    onChangeProduct,
    onClickColor,
    ...restProps
  } = props;

  const handleChangeProduct = useCallback(
    (id: number) => {
      if (onChangeProduct) onChangeProduct(id);
    },
    [onChangeProduct],
  );

  const handleClickColor = useCallback(
    (e: MouseEvent, clickedFabric: ColorData) => {
      if (onClickColor) onClickColor(e, clickedFabric);
    },
    [onClickColor],
  );

  return (
    <List
      {...restProps}
      className={cn(
        styles.fabrics,
        {
          [styles.sizeS]: size === 's',
          [styles.sizeM]: size === 'm',
          [styles.sizeL]: size === 'l',
        },
        className,
      )}
      items={fabrics}
      renderChild={(fabric: ColorData) => (
        <Link
          to={fabric.link}
          className={cn(styles.fabric, { [styles.selected]: fabric === defaultSelectedFabric })}
          onMouseEnter={() => handleChangeProduct(fabric.shopProductId)}
          onClick={(e: MouseEvent) => handleClickColor(e, fabric)}
        >
          <BackgroundImage className={styles.image} src={fabric.image} />
        </Link>
      )}
    />
  );
};

export default memo(Fabrics);
